<div class="row">
  <div class="col">
    <p-table [totalRecords]="operativeDocuments?.length" #dt [value]="operativeDocuments"
             styleClass="p-datatable-striped  p-datatable-responsive-eca" [scrollable]="!isOnMobile &&    operativeDocuments?.length > 5" scrollHeight="500px"
             [globalFilterFields]="['documentType', 'entityTypeString','operativeFullName','originalFilename','documentCreationDate.dateTime','expiryDate.dateTime',
         'reviewDate.dateTime', 'totalObservations']" [responsive]="true" [columns]="columns">
      <ng-container *ngIf="showTableCaption">
        <ng-template pTemplate="caption">
          <div class="row hide-on-small-screens">
            <div class="col-md-auto ">
              <div class="alert alert-info">
                Please note that if you are adding a document relating to a particular Training Record, then you should
                open the training record in first tab and add it there.
              </div>
            </div>
          </div>
          <div class="row d-flex justify-content-between align-items-center">
            <div class=" col-xl-auto col-lg-auto col-md-12 col-sm-12">
              <div class="row  justify-content-lg-start justify-content-md-between justify-content-sm-between justify-content-between align-items-center">
                <div class="col-auto">
                  <h5 class="eca-primary-text">
                    <span *ngIf="operativeDocuments "> {{ operativeDocuments.length  }}</span>
                    {{headerText}}
                  </h5>
                </div>
                <div class="col-auto">
                  <app-eca-ghost-btn (btnClicked)="addDocumentClicked()" *ngIf="showAddDocumentButton"
                                     [btnText]="addDocumentButtonText" btnIcon="file-plus"
                                     btnType="success">
                  </app-eca-ghost-btn>
                </div>
              </div>
            </div>
            <div class=" col-xl-auto col-lg-auto col-md-12 col-sm-12 ">
              <div class="row  justify-content-lg-end justify-content-md-end justify-content-sm-between justify-content-between align-items-center">
                <div class="col-xl-auto col-lg-auto col-md-12 col-sm-12 col-12 hide-on-small-screens">
                  <app-eca-checkbox [label]="'Include Expired?'" [(value)]="expiredFilter.includeExpired"
                                    (valueChange)="expiredFilterChanged()"></app-eca-checkbox>
                </div>
                <div class="col-xl-auto col-lg-auto col-md-12 col-sm-12 col-12">
                  <div class="row  justify-content-lg-start justify-content-md-between justify-content-sm-between justify-content-between align-items-center">
                    <div class="col-xl-auto col-lg-auto col-md-auto col-sm-8 col">
                      <span class="p-input-icon-left">
                                              <i class="pi pi-search"></i>
                                               <input pInputText type="text" class="form-control"
                                                      id="ctrlTrainingCoursesSearchInput"

                                                      placeholder="Search All"
                                                      (input)="dt.filterGlobal($event.target.value, 'contains')">
                                            </span>
                    </div>
                    <div class="col-auto">
                      <app-eca-ghost-btn btnIcon="file-excel" btnText="Export" btnType="primary"
                                         (btnClicked)="exportToExcel()">
                      </app-eca-ghost-btn>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-template>
      </ng-container>
      <ng-template pTemplate="header">
        <tr>
          <th style="width: 12%;" pSortableColumn="entityTypeString">
            Type
            <p-sortIcon field="entityTypeString"></p-sortIcon>
          </th>
          <th style="width: 10%;" pSortableColumn="documentType">
            Document Type
            <p-sortIcon field="documentType"></p-sortIcon>
          </th>
          <th style="width: 14%;" pSortableColumn="originalFilename">
            Original Filename
            <p-sortIcon field="originalFilename"></p-sortIcon>
          </th>
          <th style="width: 10%;" pSortableColumn="documentCreationDate.dateTime">
            Created On
            <p-sortIcon field="documentCreationDate.dateTime"></p-sortIcon>
          </th>
          <th style="width: 10%;" pSortableColumn="expiryDate.dateTime">
            Expires On
            <p-sortIcon field="expiryDate.dateTime"></p-sortIcon>
          </th>
          <th style="width: 10%;" pSortableColumn="reviewDate.dateTime">
            Review Due On
            <p-sortIcon field="reviewDate.dateTime"></p-sortIcon>
          </th>
          <th style="width: 10%;" pSortableColumn="totalObservations">
            Observations
            <p-sortIcon field="totalObservations"></p-sortIcon>
          </th>
          <th style="font-weight: bold; width: 10%;"></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-operativeDocument let-columns="columns" style="margin: 15px;">
        <tr>
          <td *ngFor="let col of columns">
            <span class="p-column-title">{{col.header}}: </span>
            <label>
              <span *ngIf="col.type=== 'text'">
                {{operativeDocument[col.field]}}
              </span>
              <span *ngIf="col.type=== 'link'">
                <a [routerLink]="'/operative/' + operativeDocument?.operativeId">{{operativeDocument[col.field]}}</a>
              </span>
              <span *ngIf="col.type === 'date'">
                {{operativeDocument[col.field]?.dateTime | date:'dd/MM/yyyy'}}
              </span>
              <span *ngIf="col.type === 'entityTypeString'">
                {{DocumentEntityTypeString[operativeDocument[col.field]]}}
              </span>
            </label>
          </td>
          <td>
            <div class="text-center">
              <app-eca-row-menu (viewBtnClicked)="viewDocumentClicked(operativeDocument)"
                                [rowMenuItems]="rowMenuItems"
                                [contextItem]="operativeDocument">
              </app-eca-row-menu>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
